import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../../../environments/environment';
import { MENU_ITEMS } from '../layout/menu.const';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  ButtonComponent,
  DropdownTriggerDirective,
  IconButtonComponent,
  MenuComponent,
  MenuItem,
  SvgIconComponent,
} from '@ui-lib/components';
import { LanguageService } from '../../../core/services/language/language.service';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { AsyncPipe } from '@angular/common';
import { Observable, switchMap } from 'rxjs';
import { LANGUAGE_MENU_ITEMS } from '../language-selector/language-selector.const';
import { DEFAULT_LANGUAGE } from '../../../core/services/language/language.const';

@Component({
  selector: 'rrp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    RouterLink,
    TranslateModule,
    ButtonComponent,
    MenuComponent,
    SvgIconComponent,
    LanguageSelectorComponent,
    AsyncPipe,
    IconButtonComponent,
    DropdownTriggerDirective,
  ],
})
export class HeaderComponent implements AfterViewInit {
  private readonly languageService = inject(LanguageService);
  private readonly translateService = inject(TranslateService);
  private readonly oauthService = inject(OAuthService);

  @ViewChild('languageMenu')
  private readonly languageMenu?: TemplateRef<unknown>;

  public languageMenuItems: MenuItem[] = [];
  public menuItems: MenuItem[] = [];

  public readonly currentLanguage$: Observable<string> =
    this.languageService.getCurentLanguageObservable();

  public ngAfterViewInit(): void {
    this.languageMenuItems = LANGUAGE_MENU_ITEMS.map((item: MenuItem) => {
      return {
        ...item,
        callback: (): void =>
          this.languageService.setCurrentLanguage(item.id || DEFAULT_LANGUAGE),
      } as MenuItem;
    });

    this.menuItems = [
      ...MENU_ITEMS,
      {
        titleStream$: this.languageService
          .getCurentLanguageObservable()
          .pipe(
            switchMap((language) =>
              this.translateService.stream(`language.${language}`),
            ),
          ),
        isMobileOnly: true,
        dropdownMenu: this.languageMenu,
        //TODO: add language icon
        icon: 'settings',
      },
    ];
  }

  public openRedRockPool(): void {
    const currentLanguage = this.languageService.getCurentLanguage();

    window.location.href = `${environment.poolUrl}?lang=${currentLanguage}`;
  }

  public logout(): void {
    this.oauthService.logOut();
  }

  protected readonly MENU_ITEMS = MENU_ITEMS;
}
